// eslint-disable max-len
const roleList = {
    1: 'maintainer',
    2: 'admin',
    3: 'supervisor',
    4: 'operator',
    5: 'auditor',
    6: 'administrativeAuditor'
};

const campaignWorkflows = {
    1: 'Outbound',
    2: 'Inbound'
};

const campaignTypes = {
    1: 'Survey',
    2: 'Meeting',
    3: 'PME',
    4: 'G. Current account',
    5: 'Callback'
};

const contactCallStates = {
    NO_CALLS: 'Chamadas por realizar',
    PROCESSING: 'Chamada a ser processada',
    AUDIT: 'Em auditoria',
    MEETING_SCHEDULE: 'Agendamento de reunião',
    SUCCESSFUL_ENDING: 'Finalizado',
    SEND_EMAIL: 'Envio de email',
    INTERESTED: 'Interessado',
    EMAIL_RECEPTION: 'Resposta por email',
    ADMISSION: 'Adesão',
    INTENTION: 'Intenção',
    LATE_CONTACT: 'Contacto posterior',
    OK: 'Ok',
    RECOVERED: 'Recuperado',
    NO_ANSWER: 'Não atendeu',
    NO_INTEREST: 'Sem interesse',
    WRONG_NUMBER: 'Número errado',
    NOT_ASSIGNED: 'Não atribuído',
    VOICEMAIL: 'Encaminhado para voicemail',
    REFUSED: 'Número recusado',
    INCIDENT: 'Incidência',
    UNSUCCESSFUL_ENDING: 'Finalizado sem sucesso',
    BUSY_NUMBER: 'Número ocupado',
    DUPLICATE_CONTACT: 'Contacto duplicado',
    COMPANY_TERMINATION: 'Empresa encerrada',
    RESCHEDULING_FAILED: 'Reagendado sem sucesso',
    SALE_FRAUD: 'Venda Fraudelenta',
    UNKNOWN_PROCCESS: 'Desconhecimento do processo de mudança de comercializador',
    GIVEN_UP: 'Desistência',
    CLIENT_DOUBT: 'Cliente com dúvidas',
    INCORRECT_DATA: 'Alteração de dados/Campanha errada',
    INCORRECT_NUMBER: 'Número incorrecto',
    RESCHEDULED: 'Chamada reagendada para outra altura'
};
const campaignsList = {
    1: 'Webdesign',
    2: 'Projecto Captação de Leads',
    3: 'SFIB2 VTV',
    4: 'CEVE Novos Clientes',
    5: 'SFIB2 VTV - Teste de integração',
    6: 'Spoon vending'
};

const weekDays = {
    0: 'Domingo',
    1: 'Segunda-feira',
    2: 'Terça-feira',
    3: 'Quarta-feira',
    4: 'Quinta-feira',
    5: 'Sexta-feira',
    6: 'Sábado'
};

const scriptInputTypes = [
    { value: 7, label: 'date', scriptTypesAllowed: [ 1, 2 ] },
    { value: 6, label: 'datetime', scriptTypesAllowed: [ 1, 2 ] },
    { value: 5, label: 'dropdown', scriptTypesAllowed: [ 1, 2 ] },
    { value: 4, label: 'checkbox', scriptTypesAllowed: [ 2 ] },
    { value: 3, label: 'radiobutton', scriptTypesAllowed: [ 1, 2 ] },
    { value: 1, label: 'string', scriptTypesAllowed: [ 1, 2 ] },
    { value: 2, label: 'text', scriptTypesAllowed: [ 1, 2 ] },
    { value: 100, label: 'noReply', scriptTypesAllowed: [ 1, 2 ] }
];
const districtsList = {
    1: 'Aveiro',
    2: 'Beja',
    3: 'Braga',
    4: 'Bragança',
    5: 'Castelo Branco',
    6: 'Coimbra',
    7: 'Évora',
    8: 'Faro',
    9: 'Guarda',
    10: 'Leiria',
    11: 'Lisboa',
    12: 'Portalegre',
    13: 'Porto',
    14: 'Santarém',
    15: 'Setúbal',
    16: 'Viana do Castelo',
    17: 'Vila Real',
    18: 'Viseu',
    19: 'Ilha da Madeira',
    20: 'Ilha de Porto Santo',
    21: 'Ilha de Santa Maria',
    22: 'Ilha de São Miguel',
    23: 'Ilha Terceira',
    24: 'Ilha da Graciosa',
    25: 'Ilha de São Jorge',
    26: 'Ilha do Pico',
    27: 'Ilha do Faial',
    28: 'Ilha das Flores',
    29: 'Ilha do Corvo'
};
/* eslint-disable */
const economicActivityCodesList = {
    '01111': 'Cerealicultura (excepto arroz)',
    '01112': 'Cultura de leguminosas secas e sementes oleaginosas',
    '01120': 'Cultura de arroz',
    '01130': 'Culturas de produtos hortícolas, raízes e tubérculos',
    '01140': 'Cultura de cana-de-açúcar',
    '01150': 'Cultura de tabaco',
    '01160': 'Cultura de plantas têxteis',
    '01191': 'Cultura de flores e de plantas ornamentais',
    '01192': 'Outras culturas temporárias, n.e.',
    '01210': 'Viticultura',
    '01220': 'Cultura de frutos tropicais e subtropicais',
    '01230': 'Cultura de citrinos',
    '01240': 'Cultura de pomóideas e prunóideas',
    '01251': 'Cultura de frutos de casca rija',
    '01252': 'Cultura de outros frutos em árvores e arbustos',
    '01261': 'Olivicultura',
    '01262': 'Cultura de outros frutos oleaginosos',
    '01270': 'Cultura de plantas destinadas à preparação de bebidas',
    '01280': 'Cultura de especiarias, plantas aromáticas, medicinais e farmacêuticas',
    '01290': 'Outras culturas permanentes',
    '01300': 'Cultura de materiais de propagação vegetativa',
    '01410': 'Criação de bovinos para produção de leite',
    '01420': 'Criação de outros bovinos (excepto para produção de leite) e búfalos',
    '01430': 'Criação de equinos, asininos e muares',
    '01440': 'Criação de camelos e camelídeos',
    '01450': 'Criação de ovinos e caprinos',
    '01460': 'Suinicultura',
    '01470': 'Avicultura',
    '01491': 'Apicultura',
    '01492': 'Cunicultura',
    '01493': 'Criação de animais de companhia',
    '01494': 'Outra produção animal, n.e.',
    '01500': 'Agricultura e produção animal combinadas',
    '01610': 'Actividades dos serviços relacionados com a agricultura',
    '01620': 'Actividades dos serviços relacionados com a produção animal, excepto serviços de veterinária',
    '01630': 'Preparação de produtos agrícolas para venda',
    '01640': 'Preparação e tratamento de sementes para propagação',
    '01701': 'Caça e repovoamento cinegético',
    '01702': 'Actividades dos serviços relacionados com a caça e repovoamento cinegético',
    '02100': 'Silvicultura e outras actividades florestais',
    '02200': 'Exploração florestal',
    '02300': 'Extracção de cortiça, resina e apanha de outros produtos florestais, excepto madeira',
    '02400': 'Actividades dos serviços relacionados com a silvicultura e exploração florestal',
    '03111': 'Pesca marítima',
    '03112': 'Apanha de algas e de outros produtos do mar',
    '03121': 'Pesca em águas interiores',
    '03122': 'Apanha de produtos de águas interiores',
    '03210': 'Aquicultura em águas salgadas e salobras',
    '03220': 'Aquicultura em águas doces',
    '05100': 'Extracção de hulha (inclui antracite)',
    '05200': 'Extracção de lenhite',
    '06100': 'Extracção de petróleo bruto',
    '06200': 'Extracção de gás natural',
    '07100': 'Extracção e preparação de minérios de ferro',
    '07210': 'Extracção e preparação de minérios de urânio e de tório',
    '07290': 'Extracção e preparação de outros minérios metálicos não ferrosos',
    '08111': 'Extracção de mármore e outras rochas carbonatadas',
    '08112': 'Extracção de granito ornamental e rochas similares',
    '08113': 'Extracção de calcário e cré',
    '08114': 'Extracção de gesso',
    '08115': 'Extracção de ardósia',
    '08121': 'Extracção de saibro, areia e pedra britada',
    '08122': 'Extracção de argilas e caulino',
    '08910': 'Extracção de minerais para a indústria química e para a fabricação de adubos',
    '08920': 'Extracção da turfa',
    '08931': 'Extracção de sal marinho',
    '08932': 'Extracção de sal gema',
    '08991': 'Extracção de feldspato',
    '08992': 'Extracção de outros minerais não metálicos, n.e.',
    '09100': 'Actividades dos serviços relacionados com a extracção de petróleo e gás, excepto a prospecção',
    '09900': 'Outras actividades dos serviços relacionados com as indústrias extractivas',
    '10110': 'Abate de gado (produção de carne)',
    '10120': 'Abate de aves (produção de carne)',
    '10130': 'Fabricação de produtos à base de carne',
    '10201': 'Preparação de produtos da pesca e da aquicultura',
    '10202': 'Congelação de produtos da pesca e da aquicultura',
    '10203': 'Conservação de produtos da pesca e da aquicultura em azeite e outros óleos vegetais e outros molhos',
    '10204': 'Salga, secagem e outras actividades de transformação de produtos da pesca e aquicultura',
    '10310': 'Preparação e conservação de batatas',
    '10320': 'Fabricação de sumos de frutos e de produtos hortícolas',
    '10391': 'Congelação de frutos e de produtos hortícolas',
    '10392': 'Secagem e desidratação de frutos e de produtos hortícolas',
    '10393': 'Fabricação de doces, compotas, geleias e marmelada',
    '10394': 'Descasque e transformação de frutos de casca rija comestíveis',
    '10395': 'Preparação e conservação de frutos e de produtos hortícolas por outros processos',
    '10411': 'Produção de óleos e gorduras animais brutos',
    '10412': 'Produção de azeite',
    '10413': 'Produção de óleos vegetais brutos (excepto azeite)',
    '10414': 'Refinação de azeite, óleos e gorduras',
    '10420': 'Fabricação de margarinas e de gorduras alimentares similares',
    '10510': 'Indústrias do leite e derivados',
    '10520': 'Fabricação de gelados e sorvetes',
    '10611': 'Moagem de cereais',
    '10612': 'Descasque, branqueamento e outros tratamentos do arroz',
    '10613': 'Transformação de cereais e leguminosas, n.e.',
    '10620': 'Fabricação de amidos, féculas e produtos afins',
    '10711': 'Panificação',
    '10712': 'Pastelaria',
    '10720': 'Fabricação de bolachas, biscoitos, tostas e pastelaria de conservação',
    '10730': 'Fabricação de massas alimentícias, cuscuz e similares',
    '10810': 'Indústria do açúcar',
    '10821': 'Fabricação de cacau e de chocolate',
    '10822': 'Fabricação de produtos de confeitaria',
    '10830': 'Indústria do café e do chá',
    '10840': 'Fabricação de condimentos e temperos',
    '10850': 'Fabricação de refeições e pratos pré-cozinhados',
    '10860': 'Fabricação de alimentos homogeneizados e dietéticos',
    '10891': 'Fabricação de fermentos, leveduras e adjuvantes para panificação e pastelaria',
    '10892': 'Fabricação de caldos, sopas e sobremesas',
    '10893': 'Fabricação de outros produtos alimentares diversos, n.e.',
    '10911': 'Fabricação de pré-misturas',
    '10912': 'Fabricação de alimentos para animais de criação (excepto para aquicultura)',
    '10913': 'Fabricação de alimentos para aquicultura',
    '10920': 'Fabricação de alimentos para animais de companhia',
    '11011': 'Fabricação de aguardentes preparadas',
    '11012': 'Fabricação de aguardentes não preparadas',
    '11013': 'Produção de licores e de outras bebidas destiladas',
    '11021': 'Produção de vinhos comuns e licorosos',
    '11022': 'Produção de vinhos espumantes e espumosos',
    '11030': 'Fabricação de cidra e outras bebidas fermentadas de frutos',
    '11040': 'Fabricação de vermutes e de outras bebidas fermentadas não destiladas',
    '11050': 'Fabricação de cerveja',
    '11060': 'Fabricação de malte',
    '11071': 'Engarrafamento de águas minerais naturais e de nascente',
    '11072': 'Fabricação de refrigerantes e de outras bebidas não alcoólicas, n.e.',
    '12000': 'Preparação de tabaco',
    '13101': 'Preparação e fiação de fibras do tipo algodão',
    '13102': 'Preparação e fiação de fibras do tipo lã',
    '13103': 'Preparação e fiação da seda e preparação e texturização de filamentos sintéticos e artificiais',
    '13104': 'Fabricação de linhas de costura',
    '13105': 'Preparação e fiação de linho e de outras fibras têxteis',
    '13201': 'Tecelagem de fio do tipo algodão',
    '13202': 'Tecelagem de fio do tipo lã',
    '13203': 'Tecelagem de fio do tipo seda e de outros têxteis',
    '13301': 'Branqueamento e tingimento',
    '13302': 'Estampagem',
    '13303': 'Acabamento de fios, tecidos e artigos têxteis, n.e.',
    '13910': 'Fabricação de tecidos de malha',
    '13920': 'Fabricação de artigos têxteis confeccionados, excepto vestuário',
    '13930': 'Fabricação de tapetes e carpetes',
    '13941': 'Fabricação de cordoaria',
    '13942': 'Fabricação de redes',
    '13950': 'Fabricação de não tecidos e respectivos artigos, excepto vestuário',
    '13961': 'Fabricação de passamanarias e sirgarias',
    '13962': 'Fabricação de têxteis para uso técnico e industrial, n.e.',
    '13991': 'Fabricação de bordados',
    '13992': 'Fabricação de rendas',
    '13993': 'Fabricação de outros têxteis diversos, n.e.',
    '14110': 'Confecção de vestuário em couro',
    '14120': 'Confecção de vestuário de trabalho',
    '14131': 'Confecção de outro vestuário exterior em série',
    '14132': 'Confecção de outro vestuário exterior por medida',
    '14133': 'Actividades de acabamento de artigos de vestuário',
    '14140': 'Confecção de vestuário interior',
    '14190': 'Confecção de outros artigos e acessórios de vestuário',
    '14200': 'Fabricação de artigos de peles com pêlo',
    '14310': 'Fabricação de meias e similares de malha',
    '14390': 'Fabricação de outro vestuário de malha',
    '15111': 'Curtimenta e acabamento de peles sem pêlo',
    '15112': 'Fabricação de couro reconstituído',
    '15113': 'Curtimenta e acabamento de peles com pêlo',
    '15120': 'Fabricação de artigos de viagem e de uso pessoal, de marroquinaria, de correeiro e de seleiro',
    '15201': 'Fabricação de calçado',
    '15202': 'Fabricação de componentes para calçado',
    '16101': 'Serração de madeira',
    '16102': 'Impregnação de madeira',
    '16211': 'Fabricação de painéis de partículas de madeira',
    '16212': 'Fabricação de painéis de fibras de madeira',
    '16213': 'Fabricação de folheados, contraplacados, lamelados e de outros painéis',
    '16220': 'Parqueteria',
    '16230': 'Fabricação de outras obras de carpintaria para a construção',
    '16240': 'Fabricação de embalagens de madeira',
    '16291': 'Fabricação de outras obras de madeira',
    '16292': 'Fabricação de obras de cestaria e de espartaria',
    '16293': 'Indústria de preparação da cortiça',
    '16294': 'Fabricação de rolhas de cortiça',
    '16295': 'Fabricação de outros produtos de cortiça',
    '17110': 'Fabricação de pasta',
    '17120': 'Fabricação de papel e de cartão (excepto canelado)',
    '17211': 'Fabricação de papel e de cartão canelados (inclui embalagens)',
    '17212': 'Fabricação de outras embalagens de papel e de cartão',
    '17220': 'Fabricação de artigos de papel para uso doméstico e sanitário',
    '17230': 'Fabricação de artigos de papel para papelaria',
    '17240': 'Fabricação de papel de parede',
    '17290': 'Fabricação de outros artigos de pasta de papel, de papel e de cartão',
    '18110': 'Impressão de jornais',
    '18120': 'Outra impressão',
    '18130': 'Actividades de preparação da impressão e de produtos media',
    '18140': 'Encadernação e actividades relacionadas',
    '18200': 'Reprodução de suportes gravados',
    '19100': 'Fabricação de produtos de coqueria',
    '19201': 'Fabricação de produtos petrolíferos refinados',
    '19202': 'Fabricação de produtos petrolíferos a partir de resíduos',
    '19203': 'Fabricação de briquetes e aglomerados de hulha e lenhite',
    '20110': 'Fabricação de gases industriais',
    '20120': 'Fabricação de corantes e pigmentos',
    '20130': 'Fabricação de outros produtos químicos inorgânicos de base',
    '20141': 'Fabricação de resinosos e seus derivados',
    '20142': 'Fabricação de carvão (vegetal e animal) e produtos associados',
    '20143': 'Fabricação de álcool etílico de fermentação',
    '20144': 'Fabricação de outros produtos químicos orgânicos de base, n.e.',
    '20151': 'Fabricação de adubos químicos ou minerais e de compostos azotados',
    '20152': 'Fabricação de adubos orgânicos e organo-minerais',
    '20160': 'Fabricação de matérias plásticas sob formas primárias',
    '20170': 'Fabricação de borracha sintética sob formas primárias',
    '20200': 'Fabricação de pesticidas e de outros produtos agroquímicos',
    '20301': 'Fabricação de tintas (excepto impressão), vernizes, mastiques e produtos similares',
    '20302': 'Fabricação de tintas de impressão',
    '20303': 'Fabricação de pigmentos preparados, composições vitrificáveis e afins',
    '20411': 'Fabricação de sabões, detergentes e glicerina',
    '20412': 'Fabricação de produtos de limpeza, polimento e protecção',
    '20420': 'Fabricação de perfumes, de cosméticos e de produtos de higiene',
    '20510': 'Fabricação de explosivos e artigos de pirotecnia',
    '20520': 'Fabricação de colas',
    '20530': 'Fabricação de óleos essenciais',
    '20591': 'Fabricação de biodiesel',
    '20592': 'Fabricação de produtos químicos auxiliares para uso industrial',
    '20593': 'Fabricação de óleos e massas lubrificantes, com exclusão da efectuada nas refinarias',
    '20594': 'Fabricação de outros produtos químicos diversos, n.e.',
    '20600': 'Fabricação de fibras sintéticas ou artificiais',
    '21100': 'Fabricação de produtos farmacêuticos de base',
    '21201': 'Fabricação de medicamentos',
    '21202': 'Fabricação de outras preparações e de artigos farmacêuticos',
    '22111': 'Fabricação de pneus e câmaras-de-ar',
    '22112': 'Reconstrução de pneus',
    '22191': 'Fabricação de componentes de borracha para calçado',
    '22192': 'Fabricação de outros produtos de borracha, n.e.',
    '22210': 'Fabricação de chapas, folhas, tubos e perfis de plástico',
    '22220': 'Fabricação de embalagens de plástico',
    '22230': 'Fabricação de artigos de plástico para a construção',
    '22291': 'Fabricação de componentes de plástico para calçado',
    '22292': 'Fabricação de outros artigos de plástico, n.e.',
    '23110': 'Fabricação de vidro plano',
    '23120': 'Moldagem e transformação de vidro plano',
    '23131': 'Fabricação de vidro de embalagem',
    '23132': 'Cristalaria',
    '23140': 'Fabricação de fibras de vidro',
    '23190': 'Fabricação e transformação de outro vidro (inclui vidro técnico)',
    '23200': 'Fabricação de produtos cerâmicos refractários',
    '23311': 'Fabricação de azulejos',
    '23312': 'Fabricação de ladrilhos, mosaicos e placas de cerâmica',
    '23321': 'Fabricação de tijolos',
    '23322': 'Fabricação de telhas',
    '23323': 'Fabricação de abobadilhas',
    '23324': 'Fabricação de outros produtos cerâmicos para a construção',
    '23411': 'Olaria de barro',
    '23412': 'Fabricação de artigos de uso doméstico de faiança, porcelana e grés fino',
    '23413': 'Fabricação de artigos de ornamentação de faiança, porcelana e grés fino',
    '23414': 'Actividades de decoração de artigos cerâmicos de uso doméstico e ornamental',
    '23420': 'Fabricação de artigos cerâmicos para usos sanitários',
    '23430': 'Fabricação de isoladores e peças isolantes em cerâmica',
    '23440': 'Fabricação de outros produtos em cerâmica para usos técnicos',
    '23490': 'Fabricação de outros produtos cerâmicos não refractários',
    '23510': 'Fabricação de cimento',
    '23521': 'Fabricação de cal',
    '23522': 'Fabricação de gesso',
    '23610': 'Fabricação de produtos de betão para a construção',
    '23620': 'Fabricação de produtos de gesso para a construção',
    '23630': 'Fabricação de betão pronto',
    '23640': 'Fabricação de argamassas',
    '23650': 'Fabricação de produtos de fibrocimento',
    '23690': 'Fabricação de outros produtos de betão, gesso e cimento',
    '23701': 'Fabricação de artigos de mármore e de rochas similares',
    '23702': 'Fabricação de artigos em ardósia (lousa)',
    '23703': 'Fabricação de artigos de granito e de rochas, n.e.',
    '23910': 'Fabricação de produtos abrasivos',
    '23991': 'Fabricação de misturas betuminosas',
    '23992': 'Fabricação de outros produtos minerais não metálicos diversos, n.e.',
    '24100': 'Siderurgia e fabricação de ferro-ligas',
    '24200': 'Fabricação de tubos, condutas, perfis ocos e respectivos acessórios, de aço',
    '24310': 'Estiragem a frio',
    '24320': 'Laminagem a frio de arco ou banda',
    '24330': 'Perfilagem a frio',
    '24340': 'Trefilagem a frio',
    '24410': 'Obtenção e primeira transformação de metais preciosos',
    '24420': 'Obtenção e primeira transformação de alumínio',
    '24430': 'Obtenção e primeira transformação de chumbo, zinco e estanho',
    '24440': 'Obtenção e primeira transformação de cobre',
    '24450': 'Obtenção e primeira transformação de outros metais não ferrosos',
    '24460': 'Tratamento de combustível nuclear',
    '24510': 'Fundição de ferro fundido',
    '24520': 'Fundição de aço',
    '24530': 'Fundição de metais leves',
    '24540': 'Fundição de outros metais não ferrosos',
    '25110': 'Fabricação de estruturas de construções metálicas',
    '25120': 'Fabricação de portas, janelas e elementos similares em metal',
    '25210': 'Fabricação de caldeiras e radiadores para aquecimento central',
    '25290': 'Fabricação de outros reservatórios e recipientes metálicos',
    '25300': 'Fabricação de geradores de vapor (excepto caldeiras para aquecimento central)',
    '25401': 'Fabricação de armas de caça, de desporto e defesa',
    '25402': 'Fabricação de armamento',
    '25501': 'Fabricação de produtos forjados, estampados e laminados',
    '25502': 'Fabricação de produtos por pulverometalurgia',
    '25610': 'Tratamento e revestimento de metais',
    '25620': 'Actividades de mecânica geral',
    '25710': 'Fabricação de cutelaria',
    '25720': 'Fabricação de fechaduras, dobradiças e de outras ferragens',
    '25731': 'Fabricação de ferramentas manuais',
    '25732': 'Fabricação de ferramentas mecânicas',
    '25733': 'Fabricação de peças sinterizadas',
    '25734': 'Fabricação de moldes metálicos',
    '25910': 'Fabricação de embalagens metálicas pesadas',
    '25920': 'Fabricação de embalagens metálicas ligeiras',
    '25931': 'Fabricação de produtos de arame',
    '25932': 'Fabricação de molas',
    '25933': 'Fabricação de correntes metálicas',
    '25940': 'Fabricação de rebites, parafusos e porcas',
    '25991': 'Fabricação de louça metálica e artigos de uso doméstico',
    '25992': 'Fabricação de outros produtos metálicos diversos, n.e.',
    '26110': 'Fabricação de componentes electrónicos',
    '26120': 'Fabricação de placas de circuitos electrónicos',
    '26200': 'Fabricação de computadores e de equipamento periférico',
    '26300': 'Fabricação de aparelhos e equipamentos para comunicações',
    '26400': 'Fabricação de receptores de rádio e de televisão e bens de consumo similares',
    '26511': 'Fabricação de contadores de electricidade, gás, água e de outros líquidos',
    '26512': 'Fabricação de instrumentos e aparelhos de medida, verificação, navegação e outros fins, n.e.',
    '26520': 'Fabricação de relógios e material de relojoaria',
    '26600': 'Fabricação de equipamentos de radiação, electromedicina e electroterapêutico',
    '26701': 'Fabricação de instrumentos e equipamentos ópticos não oftálmicos',
    '26702': 'Fabricação de material fotográfico e cinematográfico',
    '26800': 'Fabricação de suportes de informação magnéticos e ópticos',
    '27110': 'Fabricação de motores, geradores e transformadores eléctricos',
    '27121': 'Fabricação de material de distribuição e controlo para instalações eléctricas de alta tensão',
    '27122': 'Fabricação de material de distribuição e controlo para instalações eléctricas de baixa tensão',
    '27200': 'Fabricação de acumuladores e pilhas',
    '27310': 'Fabricação de cabos de fibra óptica',
    '27320': 'Fabricação de outros fios e cabos eléctricos e electrónicos',
    '27330': 'Fabricação de dispositivos e acessórios para instalações eléctricas de baixa tensão',
    '27400': 'Fabricação de lâmpadas eléctricas e de outro equipamento de iluminação',
    '27510': 'Fabricação de electrodomésticos',
    '27520': 'Fabricação de aparelhos não eléctricos para uso doméstico',
    '27900': 'Fabricação de outro equipamento eléctrico',
    '28110': 'Fabricação de motores e turbinas, excepto motores para aeronaves, automóveis e motociclos',
    '28120': 'Fabricação de equipamento hidráulico e pneumático',
    '28130': 'Fabricação de outras bombas e compressores',
    '28140': 'Fabricação de outras torneiras e válvulas',
    '28150': 'Fabricação de rolamentos, de engrenagens e de outros órgãos de transmissão',
    '28210': 'Fabricação de fornos e queimadores',
    '28221': 'Fabricação de ascensores e monta cargas, escadas e passadeiras rolantes',
    '28222': 'Fabricação de equipamentos de elevação e de movimentação, n.e.',
    '28230': 'Fabricação de máquinas e equipamento de escritório, excepto computadores e equipamento periférico',
    '28240': 'Fabricação de máquinas-ferramentas portáteis com motor',
    '28250': 'Fabricação de equipamento não doméstico para refrigeração e ventilação',
    '28291': 'Fabricação de máquinas de acondicionamento e de embalagem',
    '28292': 'Fabricação de balanças e de outro equipamento para pesagem',
    '28293': 'Fabricação de outras máquinas diversas de uso geral, n.e.',
    '28300': 'Fabricação de máquinas e de tractores para a agricultura, pecuária e silvicultura',
    '28410': 'Fabricação de máquinas-ferramentas para metais',
    '28490': 'Fabricação de outras máquinas-ferramentas, n.e.',
    '28910': 'Fabricação de máquinas para a metalurgia',
    '28920': 'Fabricação de máquinas para as indústrias extractivas e para a construção',
    '28930': 'Fabricação de máquinas para as indústrias alimentares, das bebidas e do tabaco',
    '28940': 'Fabricação de máquinas para as indústrias têxtil, do vestuário e do couro',
    '28950': 'Fabricação de máquinas para as indústrias do papel e do cartão',
    '28960': 'Fabricação de máquinas para as indústrias do plástico e da borracha',
    '28991': 'Fabricação de máquinas para as indústrias de materiais de construção, cerâmica e vidro',
    '28992': 'Fabricação de outras máquinas diversas para uso específico, n.e.',
    '29100': 'Fabricação de veículos automóveis',
    '29200': 'Fabricação de carroçarias, reboques e semi-reboques',
    '29310': 'Fabricação de equipamento eléctrico e electrónico para veículos automóveis',
    '29320': 'Fabricação de outros componentes e acessórios para veículos automóveis',
    '30111': 'Construção de embarcações metálicas e estruturas flutuantes, excepto de recreio e desporto',
    '30112': 'Construção de embarcações não metálicas, excepto de recreio e desporto',
    '30120': 'Construção de embarcações de recreio e de desporto',
    '30200': 'Fabricação de material circulante para caminhos-de-ferro',
    '30300': 'Fabricação de aeronaves, de veículos espaciais e equipamento relacionado',
    '30400': 'Fabricação de veículos militares de combate',
    '30910': 'Fabricação de motociclos',
    '30920': 'Fabricação de bicicletas e veículos para inválidos',
    '30990': 'Fabricação de outro equipamento de transporte, n.e.',
    '31010': 'Fabricação de mobiliário para escritório e comércio',
    '31020': 'Fabricação de mobiliário de cozinha',
    '31030': 'Fabricação de colchoaria',
    '31091': 'Fabricação de mobiliário de madeira para outros fins',
    '31092': 'Fabricação de mobiliário metálico para outros fins',
    '31093': 'Fabricação de mobiliário de outros materiais para outros fins',
    '31094': 'Actividades de acabamento de mobiliário',
    '32110': 'Cunhagem de moedas',
    '32121': 'Fabricação de filigranas',
    '32122': 'Fabricação de artigos de joalharia e de outros artigos de ourivesaria',
    '32123': 'Trabalho de diamantes e de outras pedras preciosas ou semi-preciosas para joalharia e uso industrial',
    '32130': 'Fabricação de bijutarias',
    '32200': 'Fabricação de instrumentos musicais',
    '32300': 'Fabricação de artigos de desporto',
    '32400': 'Fabricação de jogos e de brinquedos',
    '32501': 'Fabricação de material óptico oftálmico',
    '32502': 'Fabricação de material ortopédico e próteses e de instrumentos médico-cirúrgicos',
    '32910': 'Fabricação de vassouras, escovas e pincéis',
    '32991': 'Fabricação de canetas, lápis e similares',
    '32992': 'Fabricação de fechos de correr, botões e similares',
    '32993': 'Fabricação de guarda-sóis e chapéus de chuva',
    '32994': 'Fabricação de equipamento de protecção e segurança',
    '32995': 'Fabricação de caixões mortuários em madeira',
    '32996': 'Outras indústrias transformadoras diversas, n.e.',
    '33110': 'Reparação e manutenção de produtos metálicos (excepto máquinas e equipamento)',
    '33120': 'Reparação e manutenção de máquinas e equipamentos',
    '33130': 'Reparação e manutenção de equipamento electrónico e óptico',
    '33140': 'Reparação e manutenção de equipamento eléctrico',
    '33150': 'Reparação e manutenção de embarcações',
    '33160': 'Reparação e manutenção de aeronaves e de veículos espaciais',
    '33170': 'Reparação e manutenção de outro equipamento de transporte',
    '33190': 'Reparação e manutenção de outro equipamento',
    '33200': 'Instalação de máquinas e de equipamentos industriais',
    '35111': 'Produção de electricidade de origem hídrica',
    '35112': 'Produção de electricidade de origem térmica',
    '35113': 'Produção de electricidade de origem eólica, geotérmica, solar e de origem, n.e.',
    '35120': 'Transporte de electricidade',
    '35130': 'Distribuição de electricidade',
    '35140': 'Comércio de electricidade',
    '35210': 'Produção de gás',
    '35220': 'Distribuição de combustíveis gasosos por condutas',
    '35230': 'Comércio de gás por condutas',
    '35301': 'Produção e distribuição de vapor, água quente e fria e ar frio por conduta',
    '35302': 'Produção de gelo',
    '36001': 'Captação e tratamento de água',
    '36002': 'Distribuição de água',
    '37001': 'Recolha e drenagem de águas residuais',
    '37002': 'Tratamento de águas residuais',
    '38111': 'Recolha de resíduos inertes',
    '38112': 'Recolha de outros resíduos não perigosos',
    '38120': 'Recolha de resíduos perigosos',
    '38211': 'Tratamento e eliminação de resíduos inertes',
    '38212': 'Tratamento e eliminação de outros resíduos não perigosos',
    '38220': 'Tratamento e eliminação de resíduos perigosos',
    '38311': 'Desmantelamento de veículos automóveis, em fim de vida',
    '38312': 'Desmantelamento de equipamentos eléctricos e electrónicos, em fim de vida',
    '38313': 'Desmantelamento de outros equipamentos e bens, em fim de vida',
    '38321': 'Valorização de resíduos metálicos',
    '38322': 'Valorização de resíduos não metálicos',
    '39000': 'Descontaminação e actividades similares',
    '41100': 'Promoção imobiliária (desenvolvimento de projectos de edifícios)',
    '41200': 'Construção de edifícios (residenciais e não residenciais)',
    '42110': 'Construção de estradas e pistas de aeroportos',
    '42120': 'Construção de vias férreas',
    '42130': 'Construção de pontes e túneis',
    '42210': 'Construção de redes de transporte de águas, de esgotos e de outros fluídos',
    '42220': 'Construção de redes de transporte e distribuição de electricidade e redes de telecomunicações',
    '42910': 'Engenharia hidráulica',
    '42990': 'Construção de outras obras de engenharia civil, n.e.',
    '43110': 'Demolição',
    '43120': 'Preparação dos locais de construção',
    '43130': 'Perfurações e sondagens',
    '43210': 'Instalação eléctrica',
    '43221': 'Instalação de canalizações',
    '43222': 'Instalação de climatização',
    '43290': 'Outras instalações em construções',
    '43310': 'Estucagem',
    '43320': 'Montagem de trabalhos de carpintaria e de caixilharia',
    '43330': 'Revestimento de pavimentos e de paredes',
    '43340': 'Pintura e colocação de vidros',
    '43390': 'Outras actividades de acabamento em edifícios',
    '43910': 'Actividades de colocação de coberturas',
    '43991': 'Aluguer de equipamento de construção e de demolição, com operador',
    '43992': 'Outras actividades especializadas de construção diversas, n.e.',
    '45110': 'Comércio de veículos automóveis ligeiros',
    '45190': 'Comércio de outros veículos automóveis',
    '45200': 'Manutenção e reparação de veículos automóveis',
    '45310': 'Comércio por grosso de peças e acessórios para veículos automóveis',
    '45320': 'Comércio a retalho de peças e acessórios para veículos automóveis',
    '45401': 'Comércio por grosso e a retalho de motociclos, de suas peças e acessórios',
    '45402': 'Manutenção e reparação de motociclos, de suas peças e acessórios',
    '46110': 'Agentes do comércio por grosso de matérias-primas agrícolas e têxteis, animais vivos e produtos semi-acabados',
    '46120': 'Agentes do comércio por grosso de combustíveis, minérios, metais e de produtos químicos para a indústria',
    '46130': 'Agentes do comércio por grosso de madeira e materiais de construção',
    '46140': 'Agentes do comércio por grosso de máquinas, equipamento industrial, embarcações e aeronaves',
    '46150': 'Agentes do comércio por grosso de mobiliário, artigos para uso doméstico e ferragens',
    '46160': 'Agentes do comércio por grosso de têxteis, vestuário, calçado e artigos de couro',
    '46170': 'Agentes do comércio por grosso de produtos alimentares, bebidas e tabaco',
    '46180': 'Agentes especializados do comércio por grosso de outros produtos',
    '46190': 'Agentes do comércio por grosso misto sem predominância',
    '46211': 'Comércio por grosso de alimentos para animais',
    '46212': 'Comércio por grosso de tabaco em bruto',
    '46213': 'Comércio por grosso de cortiça em bruto',
    '46214': 'Comércio por grosso de cereais, sementes, leguminosas, oleaginosas e outras matérias-primas agrícolas',
    '46220': 'Comércio por grosso de flores e plantas',
    '46230': 'Comércio por grosso de animais vivos',
    '46240': 'Comércio por grosso de peles e couro',
    '46311': 'Comércio por grosso de fruta e de produtos hortícolas, excepto batata',
    '46312': 'Comércio por grosso de batata',
    '46320': 'Comércio por grosso de carne e produtos à base de carne',
    '46331': 'Comércio por grosso de leite, seus derivados e ovos',
    '46332': 'Comércio por grosso de azeite, óleos e gorduras alimentares',
    '46341': 'Comércio por grosso de bebidas alcoólicas',
    '46342': 'Comércio por grosso de bebidas não alcoólicas',
    '46350': 'Comércio por grosso de tabaco',
    '46361': 'Comércio por grosso de açúcar',
    '46362': 'Comércio por grosso de chocolate e de produtos de confeitaria',
    '46370': 'Comércio por grosso de café, chá, cacau e especiarias',
    '46381': 'Comércio por grosso de peixe, crustáceos e moluscos',
    '46382': 'Comércio por grosso de outros produtos alimentares, n.e.',
    '46390': 'Comércio por grosso não especializado de produtos alimentares, bebidas e tabaco',
    '46410': 'Comércio por grosso de têxteis',
    '46421': 'Comércio por grosso de vestuário e de acessórios',
    '46422': 'Comércio por grosso de calçado',
    '46430': 'Comércio por grosso de electrodomésticos, aparelhos de rádio e de televisão',
    '46441': 'Comércio por grosso de louças em cerâmica e em vidro',
    '46442': 'Comércio por grosso de produtos de limpeza',
    '46450': 'Comércio por grosso de perfumes e de produtos de higiene',
    '46460': 'Comércio por grosso de produtos farmacêuticos',
    '46470': 'Comércio por grosso de móveis para uso doméstico, carpetes, tapetes e artigos de iluminação',
    '46480': 'Comércio por grosso de relógios e de artigos de ourivesaria e joalharia',
    '46491': 'Comércio por grosso de artigos de papelaria',
    '46492': 'Comércio por grosso de livros, revistas e jornais',
    '46493': 'Comércio por grosso de brinquedos, jogos e artigos de desporto',
    '46494': 'Outro comércio por grosso de bens de consumo, n.e.',
    '46510': 'Comércio por grosso de computadores, equipamentos periféricos e programas informáticos',
    '46520': 'Comércio por grosso de equipamentos electrónicos, de telecomunicações e suas partes',
    '46610': 'Comércio por grosso de máquinas e equipamentos, agrícolas',
    '46620': 'Comércio por grosso de máquinas-ferramentas',
    '46630': 'Comércio por grosso de máquinas para a indústria extractiva, construção e engenharia civil',
    '46640': 'Comércio por grosso de máquinas para a indústria têxtil, máquinas de costura e de tricotar',
    '46650': 'Comércio por grosso de mobiliário de escritório',
    '46660': 'Comércio por grosso de outras máquinas e material de escritório',
    '46690': 'Comércio por grosso de outras máquinas e equipamentos',
    '46711': 'Comércio por grosso de produtos petrolíferos',
    '46712': 'Comércio por grosso de combustíveis sólidos, líquidos e gasosos, não derivados do petróleo',
    '46720': 'Comércio por grosso de minérios e de metais',
    '46731': 'Comércio por grosso de madeira em bruto e de produtos derivados',
    '46732': 'Comércio por grosso de materiais de construção (excepto madeira) e equipamento sanitário',
    '46740': 'Comércio por grosso de ferragens, ferramentas manuais e artigos para canalizações e aquecimento',
    '46750': 'Comércio por grosso de produtos químicos',
    '46761': 'Comércio por grosso de fibras têxteis naturais, artificiais e sintéticas',
    '46762': 'Comércio por grosso de outros bens intermédios, n.e.',
    '46771': 'Comércio por grosso de sucatas e de desperdícios metálicos',
    '46772': 'Comércio por grosso de desperdícios têxteis, de cartão e papéis velhos',
    '46773': 'Comércio por grosso de desperdícios de materiais, n.e.',
    '46900': 'Comércio por grosso não especializado',
    '47111': 'Comércio a retalho em supermercados e hipermercados',
    '47112': 'Comércio a retalho em outros estabelecimentos não especializados, com predominância de produtos alimentares, bebidas ou tabaco',
    '47191': 'Comércio a retalho não especializado, sem predominância de produtos alimentares, bebidas ou tabaco, em grandes armazéns e similares',
    '47192': 'Comércio a retalho em outros estabelecimentos não especializados, sem predominância de produtos alimentares, bebidas ou tabaco',
    '47210': 'Comércio a retalho de frutas e produtos hortícolas, em estabelecimentos especializados',
    '47220': 'Comércio a retalho de carne e produtos à base de carne, em estabelecimentos especializados',
    '47230': 'Comércio a retalho de peixe, crustáceos e moluscos, em estabelecimentos especializados',
    '47240': 'Comércio a retalho de pão, de produtos de pastelaria e de confeitaria, em estabelecimentos especializados',
    '47250': 'Comércio a retalho de bebidas, em estabelecimentos especializados',
    '47260': 'Comércio a retalho de tabaco, em estabelecimentos especializados',
    '47291': 'Comércio a retalho de leite e de derivados, em estabelecimentos especializados',
    '47292': 'Comércio a retalho de produtos alimentares, naturais e dietéticos, em estabelecimentos especializados',
    '47293': 'Outro comércio a retalho de produtos alimentares, em estabelecimentos especializados, n.e.',
    '47300': 'Comércio a retalho de combustível para veículos a motor, em estabelecimentos especializados',
    '47410': 'Comércio a retalho de computadores, unidades periféricas e programas informáticos, em estabelecimentos especializados',
    '47420': 'Comércio a retalho de equipamento de telecomunicações, em estabelecimentos especializados',
    '47430': 'Comércio a retalho de equipamento audiovisual, em estabelecimentos especializados',
    '47510': 'Comércio a retalho de têxteis, em estabelecimentos especializados',
    '47521': 'Comércio a retalho de ferragens e de vidro plano, em estabelecimentos especializados',
    '47522': 'Comércio a retalho de tintas, vernizes e produtos similares, em estabelecimentos especializados',
    '47523': 'Comércio a retalho de material de bricolage, equipamento sanitário, ladrilhos e materiais similares, em estabelecimentos especializados',
    '47530': 'Comércio a retalho de carpetes, tapetes, cortinados e revestimentos para paredes e pavimentos, em estabelecimentos especializados',
    '47540': 'Comércio a retalho de electrodomésticos, em estabelecimentos especializados',
    '47591': 'Comércio a retalho de mobiliário e artigos de iluminação, em estabelecimentos especializados',
    '47592': 'Comércio a retalho de louças, cutelaria e de outros artigos similares para uso doméstico, em estabelecimentos especializados',
    '47593': 'Comércio a retalho de outros artigos para o lar, n.e., em estabelecimentos especializados',
    '47610': 'Comércio a retalho de livros, em estabelecimentos especializados',
    '47620': 'Comércio a retalho de jornais, revistas e artigos de papelaria, em estabelecimentos especializados',
    '47630': 'Comércio a retalho de discos, CD, DVD, cassetes e similares, em estabelecimentos especializados',
    '47640': 'Comércio a retalho de artigos de desporto, de campismo e lazer, em estabelecimentos especializados',
    '47650': 'Comércio a retalho de jogos e brinquedos, em estabelecimentos especializados',
    '47711': 'Comércio a retalho de vestuário para adultos, em estabelecimentos especializados',
    '47712': 'Comércio a retalho de vestuário para bebés e crianças, em estabelecimentos especializados',
    '47721': 'Comércio a retalho de calçado, em estabelecimentos especializados',
    '47722': 'Comércio a retalho de marroquinaria e artigos de viagem, em estabelecimentos especializados',
    '47730': 'Comércio a retalho de produtos farmacêuticos, em estabelecimentos especializados',
    '47740': 'Comércio a retalho de produtos médicos e ortopédicos, em estabelecimentos especializados',
    '47750': 'Comércio a retalho de produtos cosméticos e de higiene, em estabelecimentos especializados',
    '47761': 'Comércio a retalho de flores, plantas, sementes e fertilizantes, em estabelecimentos especializados',
    '47762': 'Comércio a retalho de animais de companhia e respectivos alimentos, em estabelecimentos especializados',
    '47770': 'Comércio a retalho de relógios e de artigos de ourivesaria e joalharia, em estabelecimentos especializados',
    '47781': 'Comércio a retalho de máquinas e de outro material de escritório, em estabelecimentos especializados',
    '47782': 'Comércio a retalho de material óptico, fotográfico, cinematográfico e de instrumentos de precisão, em estabelecimentos especializados',
    '47783': 'Comércio a retalho de combustíveis para uso doméstico, em estabelecimentos especializados',
    '47784': 'Comércio a retalho de outros produtos novos, em estabelecimentos especializados, n.e.',
    '47790': 'Comércio a retalho de artigos em segunda mão, em estabelecimentos especializados',
    '47810': 'Comércio a retalho em bancas, feiras e unidades móveis de venda, de produtos alimentares, bebidas e tabaco',
    '47820': 'Comércio a retalho em bancas, feiras e unidades móveis de venda, de têxteis, vestuário, calçado, malas e similares',
    '47890': 'Comércio a retalho em bancas, feiras e unidades móveis de venda, de outros produtos',
    '47910': 'Comércio a retalho por correspondência ou via Internet',
    '47990': 'Comércio a retalho por outros métodos, não efectuado em estabelecimentos, bancas, feiras ou unidades móveis de venda',
    '49100': 'Transporte interurbano de passageiros por caminho-de-ferro',
    '49200': 'Transporte de mercadorias por caminhos-de-ferro',
    '49310': 'Transportes terrestres, urbanos e suburbanos, de passageiros',
    '49320': 'Transporte ocasional de passageiros em veículos ligeiros',
    '49391': 'Transporte interurbano em autocarros',
    '49392': 'Outros transportes terrestres de passageiros diversos, n.e',
    '49410': 'Transportes rodoviários de mercadorias',
    '49420': 'Actividades de mudanças, por via rodoviária',
    '49500': 'Transportes por oleodutos ou gasodutos',
    '50101': 'Transportes marítimos não costeiros de passageiros',
    '50102': 'Transportes costeiros e locais de passageiros',
    '50200': 'Transportes marítimos de mercadorias',
    '50300': 'Transportes de passageiros por vias navegáveis interiores',
    '50400': 'Transportes de mercadorias por vias navegáveis interiores',
    '51100': 'Transportes aéreos de passageiros',
    '51210': 'Transportes aéreos de mercadorias',
    '51220': 'Transportes espaciais',
    '52101': 'Armazenagem frigorífica',
    '52102': 'Armazenagem não frigorífica',
    '52211': 'Gestão de infra-estruturas dos transportes terrestres',
    '52212': 'Assistência a veículos na estrada',
    '52213': 'Outras actividades auxiliares dos transportes terrestres',
    '52220': 'Actividades auxiliares dos transportes por água',
    '52230': 'Actividades auxiliares dos transportes aéreos',
    '52240': 'Manuseamento de carga',
    '52291': 'Organização do transporte',
    '52292': 'Agentes aduaneiros e similares de apoio ao transporte',
    '53100': 'Actividades postais sujeitas a obrigações do serviço universal',
    '53200': 'Outras actividades postais e de courier',
    '55111': 'Hotéis com restaurante',
    '55112': 'Pensões com restaurante',
    '55113': 'Estalagens com restaurante',
    '55114': 'Pousadas com restaurante',
    '55115': 'Motéis com restaurante',
    '55116': 'Hotéis-Apartamentos com restaurante',
    '55117': 'Aldeamentos turísticos com restaurante',
    '55118': 'Apartamentos turísticos com restaurante',
    '55119': 'Outros estabelecimentos hoteleiros com restaurante',
    '55121': 'Hotéis sem restaurante',
    '55122': 'Pensões sem restaurante',
    '55123': 'Apartamentos turísticos sem restaurante',
    '55124': 'Outros estabelecimentos hoteleiros sem restaurante',
    '55201': 'Alojamento mobilado para turistas',
    '55202': 'Turismo no espaço rural',
    '55203': 'Colónias e campos de férias',
    '55204': 'Outros locais de alojamento de curta duração',
    '55300': 'Parques de campismo e de caravanismo',
    '55900': 'Outros locais de alojamento',
    '56101': 'Restaurantes tipo tradicional',
    '56102': 'Restaurantes com lugares ao balcão',
    '56103': 'Restaurantes sem serviço de mesa',
    '56104': 'Restaurantes típicos',
    '56105': 'Restaurantes com espaço de dança',
    '56106': 'Confecção de refeições prontas a levar para casa',
    '56107': 'Restaurantes, n.e. (inclui actividades de restauração em meios móveis)',
    '56210': 'Fornecimento de refeições para eventos',
    '56290': 'Outras actividades de serviço de refeições',
    '56301': 'Cafés',
    '56302': 'Bares',
    '56303': 'Pastelarias e casas de chá',
    '56304': 'Outros estabelecimentos de bebidas sem espectáculo',
    '56305': 'Estabelecimentos de bebidas com espaço de dança',
    '56306': 'Estabelecimentos de bebidas itinerantes (Lei n.º 66/2018, de 3 de dezembro)',
    '58110': 'Edição de livros',
    '58120': 'Edição de listas destinadas a consulta',
    '58130': 'Edição de jornais',
    '58140': 'Edição de revistas e de outras publicações periódicas',
    '58190': 'Outras actividades de edição',
    '58210': 'Edição de jogos de computador',
    '58290': 'Edição de outros programas informáticos',
    '59110': 'Produção de filmes, de vídeos e de programas de televisão',
    '59120': 'Actividades técnicas de pós-produção para filmes, vídeos e programas de televisão',
    '59130': 'Distribuição de filmes, de vídeos e de programas de televisão',
    '59140': 'Projecção de filmes e de vídeos',
    '59200': 'Actividades de gravação de som e edição de música',
    '60100': 'Actividades de rádio',
    '60200': 'Actividades de televisão',
    '61100': 'Actividades de telecomunicações por fio',
    '61200': 'Actividades de telecomunicações sem fio',
    '61300': 'Actividades de telecomunicações por satélite',
    '61900': 'Outras actividades de telecomunicações',
    '62010': 'Actividades de programação informática',
    '62020': 'Actividades de consultoria em informática',
    '62030': 'Gestão e exploração de equipamento informático',
    '62090': 'Outras actividades relacionadas com as tecnologias da informação e informática',
    '63110': 'Actividades de processamento de dados, domiciliação de informação e actividades relacionadas',
    '63120': 'Portais Web',
    '63910': 'Actividades de agências de notícias',
    '63990': 'Outras actividades dos serviços de informação, n.e.',
    '64110': 'Banco central',
    '64190': 'Outra intermediação monetária',
    '64201': 'Actividades das sociedades gestoras de participações sociais financeiras',
    '64202': 'Actividades das sociedades gestoras de participações sociais não financeiras',
    '64300': 'Trusts, fundos e entidades financeiras similares',
    '64910': 'Actividades de locação financeira',
    '64921': 'Actividades das instituições financeiras de crédito',
    '64922': 'Actividades das sociedades financeiras para aquisições a crédito',
    '64923': 'Outras actividades de crédito, n.e.',
    '64991': 'Actividades de factoring',
    '64992': 'Outras actividades de serviços financeiros diversos, n.e., excepto seguros e fundos de pensões',
    '65111': 'Seguros de vida',
    '65112': 'Outras actividades complementares de segurança social',
    '65120': 'Seguros não vida',
    '65200': 'Resseguros',
    '65300': 'Fundos de pensões e regimes profissionais complementares',
    '66110': 'Administração de mercados financeiros',
    '66120': 'Actividades de negociação por conta de terceiros em valores mobiliários e outros instrumentos financeiros',
    '66190': 'Outras actividades auxiliares de serviços financeiros, excepto seguros e fundos de pensões',
    '66210': 'Actividades de avaliação de riscos e danos',
    '66220': 'Actividades de mediadores de seguros',
    '66290': 'Outras actividades auxiliares de seguros e fundos de pensões',
    '66300': 'Actividades de gestão de fundos',
    '68100': 'Compra e venda de bens imobiliários',
    '68200': 'Arrendamento de bens imobiliários',
    '68311': 'Actividades de mediação imobiliária',
    '68312': 'Actividades de angariação imobiliária',
    '68313': 'Actividades de avaliação imobiliária',
    '68321': 'Administração de imóveis por conta de outrem',
    '68322': 'Administração de condomínios',
    '69101': 'Actividades jurídicas',
    '69102': 'Actividades dos cartórios notariais',
    '69200': 'Actividades de contabilidade e auditoria; consultoria fiscal',
    '70100': 'Actividades das sedes sociais',
    '70210': 'Actividades de relações públicas e comunicação',
    '70220': 'Outras actividades de consultoria para os negócios e a gestão',
    '71110': 'Actividades de arquitectura',
    '71120': 'Actividades de engenharia e técnicas afins',
    '71200': 'Actividades de ensaios e análises técnicas',
    '72110': 'Investigação e desenvolvimento em biotecnologia',
    '72190': 'Outra investigação e desenvolvimento das ciências físicas e naturais',
    '72200': 'Investigação e desenvolvimento das ciências sociais e humanas',
    '73110': 'Agências de publicidade',
    '73120': 'Actividades de representação nos meios de comunicação',
    '73200': 'Estudos de mercado e sondagens de opinião',
    '74100': 'Actividades de design',
    '74200': 'Actividades fotográficas',
    '74300': 'Actividades de tradução e interpretação',
    '74900': 'Outras actividades de consultoria, científicas, técnicas e similares, n.e.',
    '75000': 'Actividades veterinárias',
    '77110': 'Aluguer de veículos automóveis ligeiros',
    '77120': 'Aluguer de veículos automóveis pesados',
    '77210': 'Aluguer de bens recreativos e desportivos',
    '77220': 'Aluguer de videocassetes e discos',
    '77290': 'Aluguer de outros bens de uso pessoal e doméstico',
    '77310': 'Aluguer de máquinas e equipamentos agrícolas',
    '77320': 'Aluguer de máquinas e equipamentos para a construção e engenharia civil',
    '77330': 'Aluguer de máquinas e equipamentos de escritório (inclui computadores)',
    '77340': 'Aluguer de meios de transporte marítimo e fluvial',
    '77350': 'Aluguer de meios de transporte aéreo',
    '77390': 'Aluguer de outras máquinas e equipamentos, n.e.',
    '77400': 'Locação de propriedade intelectual e produtos similares, excepto direitos de autor',
    '78100': 'Actividades das empresas de selecção e colocação de pessoal',
    '78200': 'Actividades das empresas de trabalho temporário',
    '78300': 'Outro fornecimento de recursos humanos',
    '79110': 'Actividades das agências de viagem',
    '79120': 'Actividades dos operadores turísticos',
    '79900': 'Outros serviços de reservas e actividades relacionadas',
    '80100': 'Actividades de segurança privada',
    '80200': 'Actividades relacionadas com sistemas de segurança',
    '80300': 'Actividades de investigação',
    '81100': 'Actividades combinadas de apoio aos edifícios',
    '81210': 'Actividades de limpeza geral em edifícios',
    '81220': 'Outras actividades de limpeza em edifícios e em equipamentos industriais',
    '81291': 'Actividades de desinfecção, desratização e similares',
    '81292': 'Outras actividades de limpeza, n.e.',
    '81300': 'Actividades de plantação e manutenção de jardins',
    '82110': 'Actividades combinadas de serviços administrativos',
    '82190': 'Execução de fotocópias, preparação de documentos e outras actividades especializadas de apoio administrativo',
    '82200': 'Actividades dos centros de chamadas',
    '82300': 'Organização de feiras, congressos e outros eventos similares',
    '82910': 'Actividades de cobranças e avaliação de crédito',
    '82921': 'Engarrafamento de gases',
    '82922': 'Outras actividades de embalagem',
    '82990': 'Outras actividades de serviços de apoio prestados às empresas, n.e.',
    '84111': 'Administração Central',
    '84112': 'Administração Regional Autónoma',
    '84113': 'Administração Local',
    '84114': 'Actividades de apoio à administração pública',
    '84121': 'Administração Pública - actividades de saúde',
    '84122': 'Administração Pública - actividades de educação',
    '84123': 'Administração Pública - actividades da cultura, desporto, recreativas, ambiente, habitação e de outras actividades sociais, excepto segurança social obrigatória',
    '84130': 'Administração pública - actividades económicas',
    '84210': 'Negócios estrangeiros',
    '84220': 'Actividades de defesa',
    '84230': 'Actividades de justiça',
    '84240': 'Actividades de segurança e ordem pública',
    '84250': 'Actividades de protecção civil',
    '84300': 'Actividades de segurança social obrigatória',
    '85100': 'Educação pré-escolar',
    '85201': 'Ensino básico (1º Ciclo)',
    '85202': 'Ensino básico (2º Ciclo)',
    '85310': 'Ensinos básico (3º Ciclo) e secundário geral',
    '85320': 'Ensinos secundário tecnológico, artístico e profissional',
    '85410': 'Ensino pós-secundário não superior',
    '85420': 'Ensino superior',
    '85510': 'Ensinos desportivo e recreativo',
    '85520': 'Ensino de actividades culturais',
    '85530': 'Escolas de condução e pilotagem',
    '85591': 'Formação profissional',
    '85592': 'Escolas de línguas',
    '85593': 'Outras actividades educativas, n.e.',
    '85600': 'Actividades de serviços de apoio à educação',
    '86100': 'Actividades dos estabelecimentos de saúde com internamento',
    '86210': 'Actividades de prática médica de clínica geral, em ambulatório',
    '86220': 'Actividades de prática médica de clínica especializada, em ambulatório',
    '86230': 'Actividades de medicina dentária e odontologia',
    '86901': 'Laboratórios de análises clínicas',
    '86902': 'Actividades de ambulâncias',
    '86903': 'Actividades de enfermagem',
    '86904': 'Centros de recolha e bancos de órgãos',
    '86905': 'Actividades termais',
    '86906': 'Outras actividades de saúde humana, n.e.',
    '87100': 'Actividades dos estabelecimentos de cuidados continuados integrados, com alojamento',
    '87200': 'Actividades dos estabelecimentos para pessoas com doença do foro mental e do abuso de drogas, com alojamento',
    '87301': 'Actividades de apoio social para pessoas idosas, com alojamento',
    '87302': 'Actividades de apoio social para pessoas com deficiência, com alojamento',
    '87901': 'Actividades de apoio social para crianças e jovens, com alojamento',
    '87902': 'Actividades de apoio social com alojamento, n.e.',
    '88101': 'Actividades de apoio social para pessoas idosas, sem alojamento',
    '88102': 'Actividades de apoio social para pessoas com deficiência, sem alojamento',
    '88910': 'Actividades de cuidados para crianças, sem alojamento',
    '88990': 'Outras actividades de apoio social sem alojamento, n.e.',
    '90010': 'Actividades das artes do espectáculo',
    '90020': 'Actividades de apoio às artes do espectáculo',
    '90030': 'Criação artística e literária',
    '90040': 'Exploração de salas de espectáculos e actividades conexas',
    '91011': 'Actividades das bibliotecas',
    '91012': 'Actividades dos arquivos',
    '91020': 'Actividades dos museus',
    '91030': 'Actividades dos sítios e monumentos históricos',
    '91041': 'Actividades dos jardins zoológicos, botânicos e aquários',
    '91042': 'Actividade dos parques e reservas naturais',
    '92000': 'Lotarias e outros jogos de aposta',
    '93110': 'Gestão de instalações desportivas',
    '93120': 'Actividades dos clubes desportivos',
    '93130': 'Actividades de ginásio (fitness)',
    '93191': 'Organismos reguladores das actividades desportivas',
    '93192': 'Outras actividades desportivas, n.e.',
    '93210': 'Actividades dos parques de diversão e temáticos',
    '93211': 'Atividades de parques de diversão itinerantes (Lei n.º 66/2018, de 3 de dezembro)',
    '93291': 'Actividades tauromáquicas',
    '93292': 'Actividades dos portos de recreio (marinas)',
    '93293': 'Organização de actividades de animação turística',
    '93294': 'Outras actividades de diversão e recreativas, n.e.',
    '93295': 'Outras atividades de diversão itinerantes (Lei n.º 66/2018, de 3 de dezembro)',
    '94110': 'Actividades de organizações económicas e patronais',
    '94120': 'Actividades de organizações profissionais',
    '94200': 'Actividades de organizações sindicais',
    '94910': 'Actividades de organizações religiosas',
    '94920': 'Actividades de organizações políticas',
    '94991': 'Associações culturais e recreativas',
    '94992': 'Associações de defesa do ambiente',
    '94993': 'Associações de juventude e de estudantes',
    '94994': 'Associações de pais e encarregados de educação',
    '94995': 'Outras actividades associativas, n.e.',
    '95110': 'Reparação de computadores e de equipamento periférico',
    '95120': 'Reparação de equipamento de comunicação',
    '95210': 'Reparação de televisores e de outros bens de consumo similares',
    '95220': 'Reparação de electrodomésticos e de outros equipamentos de uso doméstico e para jardim',
    '95230': 'Reparação de calçado e de artigos de couro',
    '95240': 'Reparação de mobiliário e similares, de uso doméstico',
    '95250': 'Reparação de relógios e de artigos de joalharia',
    '95290': 'Reparação de outros bens de uso pessoal e doméstico',
    '96010': 'Lavagem e limpeza a seco de têxteis e peles',
    '96021': 'Salões de cabeleireiro',
    '96022': 'Institutos de beleza',
    '96030': 'Actividades funerárias e conexas',
    '96040': 'Actividades de bem-estar físico',
    '96091': 'Actividades de tatuagem e similares',
    '96092': 'Actividades dos serviços para animais de companhia',
    '96093': 'Outras actividades de serviços pessoais diversas, n.e.',
    '97000': 'Actividades das famílias empregadoras de pessoal doméstico',
    '98100': 'Actividades de produção de bens pelas famílias para uso próprio',
    '98200': 'Actividades de produção de serviços pelas famílias para uso próprio',
    '99000': 'Actividades dos organismos internacionais e outras instituições extra-territoriais',

};
/* eslint-enable */

const campaignScriptTypes = {
    1: 'chained',
    2: 'sequence'
};

export {
    roleList,
    campaignTypes,
    campaignWorkflows,
    contactCallStates,
    campaignsList,
    weekDays,
    scriptInputTypes,
    districtsList,
    economicActivityCodesList,
    campaignScriptTypes
};